define('shared/remote/ajax',[
    '$', 
    'shared/lib/RSVP', 
    'shared/my/accessToken', 
    'shared/page/apiVersion'
],
function(
    $, 
    RSVP, 
    myAccessToken, 
    getAPIVersion
){
    return function(options) {
        var args = arguments;
        var resolveXHR = options.resolveXHR;
        delete options.XHR;

        return RSVP.resolve()
            .then(function(){
                if (options.data && typeof options.data !== 'string') {
                    options.data = JSON.stringify(options.data);
                }
                return getAPIVersion();
            })
            .then(function(apiVersion){
                if (apiVersion === 'new-house') {
                    return myAccessToken.get();
                }
                else {
                    return RSVP.resolve();
                }
            })
            .then(function(accessToken){
                if (accessToken) {
                    if (!options.headers) {
                        options.headers = {};
                    }
                    options.headers['Authorization'] = 'Bearer ' + accessToken;
                }
                if (!options.contentType) {
                    options.contentType = 'application/json';
                }

                var jqXHR = $.ajax
                    .apply(this, args);
                if (resolveXHR) {
                    return jqXHR.promise()
                        .then(function(data){
                            return {
                                xhr: jqXHR,
                                data: data
                            };
                        });
                }
                else {
                    return jqXHR.promise();
                }
            })
            .then(null, function(xhr){
                // This is to workaround that jQuery messed up normal object with 
                // Promise methods, because when you return an object with .then
                // inside a Promise then callback, that object.then will be called
                // because of duck typing was used.
                // however this shitty Promise-like object from jquery somehow
                // doesn't get resolved
                delete xhr.then;
                delete xhr.fail;
                delete xhr.done;
                return RSVP.reject(xhr);
            });
    };
});
